export default __webpack_public_path__ + "static/media/WM0370.34I-43150_-25811_0.005e3931.jpg";